import { IsEnum, IsOptional, IsString, MaxLength } from 'class-validator'
import { Transform } from 'class-transformer'

export enum FarmCsrDocumentType {
  Certification = 'certification',
  Training = 'training',
  SoilTest = 'soil test',
  Other = 'other',
}

export class FarmCsrDocumentUploadDto {
  @IsOptional()
  @IsString()
  @MaxLength(255)
  @Transform(({ value }) => (typeof value === 'string' ? value.trim() : value))
  description?: string

  /** certification | training | soil test | other */
  @IsEnum(FarmCsrDocumentType)
  @Transform(({ value }) => (typeof value === 'string' ? value.trim().toLowerCase() : value))
  type!: FarmCsrDocumentType
}
